import { toRaw } from "vue"
import queryString from 'query-string'

const mergeUrlWithParams = (url, options) => {
  return computed(() => {
    const { params, query } = options ?? {}
    const u = toRaw(url)
    const [baseUrl, existingQuery = ""] = `${u}`.includes("?") ? u.split("?") : [u, ""]

    const newQuery = queryString.stringify(toRaw(params))

    let combinedQuery = [existingQuery, newQuery].filter(Boolean).join("&")
    if (query) {
      combinedQuery += "&" + query
    }

    return combinedQuery ? `${baseUrl}?${combinedQuery}` : baseUrl
  })
}

export const useApi = async (url, options = {}) => {
  const config = useRuntimeConfig()
  const { data: auth } = useAuth()

  const accessToken = auth?.value?.token

  const headers = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...options?.headers ?? [],
  }

  const method = options?.method?.toUpperCase() ?? "GET"

  const defaults = {
    baseURL: config.public.apiBaseUrl,
    watch: false,
    headers,
  }

  const fullUrl = mergeUrlWithParams(url, options)

  let finalOptions = {}
  if (method === "GET") {
    url = fullUrl
    finalOptions = { ...defaults }
  } else {
    // Keep the auth header from defaults while adding request-specific headers.
    finalOptions = { ...defaults, ...options, headers }
  }
  finalOptions.key = finalOptions.key || (fullUrl.value + method)

  return useFetch(url, finalOptions)
}
